<template>
  <div class="mini-prod-card">
    <div class="cross-item width156 mr12 flex-column justify-content-between">
      <div
        class="mpc-img pr"
        :style="{
          backgroundImage: `url(${getImageUrl(cardItem)})`,
          backgroundSize: 'contain',
        }"
      >
        <div v-if="discountMessage" class="cross-sell-discount">
          <p class="fs-11">{{ discountMessage }}</p>
        </div>
        <div v-if="mostPopular" class="most-popular">
          <p class="fs-11">MOST POPULAR</p>
        </div>
        <!-- <img alt="crossell image" :src="getImageUrl(cardItem)" /> -->

        <div class="mpc-item-body">
          <div class="mpc-item-tag mb5">
            <i :class="[!cardItem.isNonVeg ? 'tag-veg' : 'tag-non-veg']"></i>
          </div>
          <div class="fs-12 tl mb9 multi-line-ellipses-v2 mh-28 color-white">
            {{ cardItem?.productMetadata?.name }}
          </div>
          <div class="flex-row justify-content-between align-items-center">
            <div class="price">
              <span class="rs">Rs.</span>
              <span class="bold">{{
                cardItem?.productMetadata?.currentPrice || 0.0
              }}</span>
            </div>

            <div class="main-cta">
              <!-- if quantity > 0 -->
              <!-- <div class="cta-edit" v-if="quantity > 0">
                    <span class="anim-ico-minus item-status-anim"></span>

                    <span class="fs-14 mr5 ml5">2</span>

                    <span class="anim-ico-plus tr item-status-anim"></span>
                  </div> -->
              <!-- if quantity == 0 -->
              <button
                class="btn bold hand cta-add"
                @click="addtocart(cardItem)"
              >
                Add <span class="ico-plus">&#43;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import {
  EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE,
  EVENT_CART_CROSS_SELL_COLLAPSE,
} from "../helpers/analyticsEvents";

export default {
  name: "MiniProductCard",
  components: {},
  props: {
    cardItem: { required: true, default: false },
    strickPriceEnable: { required: false, default: false },
    strickPrice: { required: false, default: 0 },
    dataItemIndex: { required: false, default: 0 },
    totalItems: { required: false, default: 0 },
  },
  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  mounted() {},
  methods: {
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    addToCartEvents() {
      const {
        isVeg,
        displayName,
        parentSkuId,
        selectedVariant,
        productMetadata,
      } = this.productItem;
      EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE({
        cartId: LocalStorageFunc.cartId(),
        itemSKU: Utility.getProductSkuId(this.productItem),
        quantity: 1,
        isVegItem: isVeg ? "Veg" : "Non veg",
        itemName: displayName,
        itemOriginalPrice: productMetadata?.regularPrice,
        price: productMetadata?.currentPrice,
        itemPosition: this.dataItemIndex + 1,
        positionWithinSection: this.dataItemIndex + 1,
        itemCategory: parentSkuId,
        isCustomizedItem: selectedVariant?.defaultVariant ? "No" : "Yes",
      });

      if (this.totalItems.length == 1) {
        EVENT_CART_CROSS_SELL_COLLAPSE();
      }
    },
    addtocart(productSelected) {
      this.productItem = productSelected;
      this.addToCartEvents();
      if (
        (this.productItem?.variants?.length > 0 &&
          this.productItem?.variants?.[0].attributes?.length > 0) ||
        this.productItem?.variants?.find((x) => x.defaultVariant)?.upSell ||
        this.productItem?.comboUID
      ) {
        let cartItems = LocalStorageFunc.getCart();
        if (
          (cartItems[Utility.getParentSkuId(this.productItem)] &&
            cartItems[Utility.getParentSkuId(this.productItem)].length > 0) ||
          (cartItems[Utility.getComboSkuId(this.productItem)] &&
            cartItems[Utility.getComboSkuId(this.productItem)].length > 0)
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL,
            true
          );
        } else {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
            true
          );
        }
        this.updateShowCustomisableFor();
        return;
      }
      let product =
        this.$store.state.ProductItems.products[
          Object.keys(
            this.$store.state.ProductItems.productCategoryMap[
              Utility.getProductSkuId(this.productItem?.productMetadata)
            ]
          )[0]
        ][Utility.getProductSkuId(this.productItem?.productMetadata)];
      this.$store.commit(
        keyMapsMutation.ADD_TO_CART,
        product.variants?.find((x) => x.defaultVariant)
          ? {
              ...product,
              selectedVariant: product.variants?.find((x) => x.defaultVariant),
            }
          : { ...product }
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
      if (Utility.isCurrentlyAtUrl("/cart")) {
        this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API, {});
      }
    },
    getImageUrl(cardItem) {
      let url = "";
      cardItem?.productMetadata?.mediaMetadata?.length &&
        cardItem?.productMetadata?.mediaMetadata.map((x) => {
          if (x.mediaType === "IMAGE") {
            url =
              x.url ||
              staticImgBaseUrl +
                "/images/global/hongs-default-img-lg-grey.jpeg";
          }
        });
      return url;
    },
    updateShowCustomisableFor() {
      //document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR,
        Utility.getParentSkuId(this.productItem) ||
          Utility.getComboSkuId(this.productItem)
      );
    },
  },
  computed: {
    discountMessage() {
      let discountMessage = "";
      this.cardItem.productMetadata?.properties?.map((x) => {
        if (x.key === "discount_message") {
          discountMessage = x.values;
        }
      });
      return discountMessage;
    },
    mostPopular() {
      let isMostPopular = false;
      this.cardItem.productMetadata?.properties?.map((x) => {
        if (x.key === "most_popular") {
          isMostPopular = x.values;
        }
      });
      return isMostPopular;
    },
  },
};
</script>

<style></style>
